var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper"},[_c('b-table',{attrs:{"hover":"","items":_vm.departments,"fields":_vm.fields,"tbody-tr-class":['clickable-row']},on:{"row-clicked":_vm.goToDepartment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }